import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import Empresas from '../pages/Empresas';
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';
import { PrivateRoute } from './PrivateRoute';
import Users from '../pages/Users';
import Settings from '../pages/Settings';
import CadastroModeloPage from '../pages/CadastroModelo';
import EmpresasProvider from '../context/EmpresasContext';

export default function Rotas() {
  const loginData = localStorage.getItem('loggedData');
  return (
    <Router>
      <EmpresasProvider>
        <Routes>
          <Route path="/" element={loginData ? <Navigate to="/empresas" /> : <Navigate to="/login" />} />
          <Route path="/login" element={loginData ? <Navigate to="/empresas" /> : <Login />} />
          <Route path="/empresas" element={
            <PrivateRoute>
              <Empresas />
            </PrivateRoute>
          } />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/cadastro-modelo/:companyId?/:id?" element={
            <PrivateRoute>
              <CadastroModeloPage />
            </PrivateRoute>
          } />
          <Route path="/users" element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          } />
          <Route path="/settings" element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          } />
        </Routes>
      </EmpresasProvider>
    </Router >
  );
}
